(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function addReveal(el, direction = 'up', delay = 0, hero = false) {
    if (!el || el.dataset.ppv9Reveal === '1') return;
    el.dataset.ppv9Reveal = '1';
    el.style.setProperty('--ppv9-delay', `${delay}ms`);
    el.classList.add(hero ? 'ppv9-hero-reveal' : 'ppv9-reveal');
    if (hero && direction === 'media') el.classList.add('ppv9-hero-reveal--media');
    if (!hero && direction === 'left') el.classList.add('ppv9-reveal--left');
    if (!hero && direction === 'right') el.classList.add('ppv9-reveal--right');
    if (!hero && direction === 'scale') el.classList.add('ppv9-reveal--scale');
  }

  function stagger(nodes, start = 0, step = 110, direction = 'up') {
    [...nodes].forEach((el, i) => addReveal(el, direction, start + (i * step)));
  }

  function setupRoot(root) {
    if (!root || root.dataset.ppv9MotionReady === '1') return;
    root.dataset.ppv9MotionReady = '1';
    root.classList.add('ppv9-motion');

    const heroMedia = root.querySelector('.ppv8-media-column');
    addReveal(heroMedia, 'media', 40, true);
    const heroCopy = root.querySelector('.ppv8-hero-copy');
    if (heroCopy) {
      stagger(heroCopy.children, 120, 115, 'up');
      [...heroCopy.children].forEach(el => el.classList.replace('ppv9-reveal', 'ppv9-hero-reveal'));
    }

    addReveal(root.querySelector('.ppv8-announcement'), 'up', 0);
    addReveal(root.querySelector('.ppv8-nav'), 'up', 35);

    stagger(root.querySelectorAll('.ppv8-confidence article'), 0, 90, 'up');

    addReveal(root.querySelector('.ppv8-editorial-image'), 'left', 0);
    const editorialCopy = root.querySelector('.ppv8-editorial-copy');
    if (editorialCopy) stagger(editorialCopy.children, 90, 105, 'right');

    const giftCopy = root.querySelector('.ppv8-gift-copy');
    if (giftCopy) stagger(giftCopy.children, 0, 105, 'left');
    addReveal(root.querySelector('.ppv8-gift-image'), 'right', 130);

    const featureHead = root.querySelector('.ppv8-features .ppv8-section-head');
    if (featureHead) stagger(featureHead.children, 0, 105, 'up');
    stagger(root.querySelectorAll('.ppv8-feature-grid article'), 80, 95, 'scale');

    const motionCopy = root.querySelector('.ppv8-motion-copy');
    if (motionCopy) stagger(motionCopy.children, 0, 105, 'left');
    addReveal(root.querySelector('.ppv8-motion-section .pp-motion'), 'right', 130);

    const setHead = root.querySelector('.ppv8-set-section .ppv8-section-head');
    if (setHead) stagger(setHead.children, 0, 105, 'up');
    stagger(root.querySelectorAll('.ppv8-set-grid article'), 80, 120, 'scale');

    addReveal(root.querySelector('.ppv8-included-image'), 'left', 0);
    const includedCopy = root.querySelector('.ppv8-included-copy');
    if (includedCopy) stagger(includedCopy.children, 80, 105, 'right');
    stagger(root.querySelectorAll('.ppv8-included-copy li'), 170, 80, 'up');

    addReveal(root.querySelector('.ppv8-delivery-image'), 'left', 0);
    const deliveryCopy = root.querySelector('.ppv8-delivery-copy');
    if (deliveryCopy) stagger(deliveryCopy.children, 90, 105, 'right');
    stagger(root.querySelectorAll('.ppv8-delivery-copy li'), 170, 85, 'up');

    const faqHead = root.querySelector('.ppv8-faq .ppv8-section-head');
    if (faqHead) stagger(faqHead.children, 0, 100, 'up');
    stagger(root.querySelectorAll('.ppv8-faq details'), 60, 70, 'up');

    const finalCta = root.querySelector('.ppv8-final-cta');
    if (finalCta) stagger(finalCta.children, 0, 120, 'up');

    const payments = root.querySelector('.ppv8-payments');
    if (payments) stagger(payments.children, 0, 110, 'up');

    const footer = root.querySelector('.ppv8-footer');
    if (footer) stagger(footer.children, 0, 90, 'up');

    const targets = [...root.querySelectorAll('.ppv9-reveal')];
    const heroTargets = [...root.querySelectorAll('.ppv9-hero-reveal')];

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      [...targets, ...heroTargets].forEach(el => el.classList.add('is-visible'));
      return;
    }

    requestAnimationFrame(() => {
      heroTargets.forEach(el => el.classList.add('is-visible'));
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -9% 0px'
    });

    targets.forEach(el => observer.observe(el));
  }

  function boot(scope = document) {
    scope.querySelectorAll('.ppv8[data-pp-root]').forEach(setupRoot);
  }

  boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
